import type { NavRailItem } from './config';

export interface SectionBadge {
  /** One of the section's pages has a badge, so its heading carries a dot. */
  has: boolean;
  /** The heading's accessible name and tooltip. Just the label when there is no dot. */
  name: string;
}

/**
 * What a section heading says about its pages' badges. It is built from the
 * first badged page's own words, so it is not tied to any one page: with the
 * Venues badge up, "Workshops, 3 open tasks in Venues". Both the rail and the
 * drawer read it, so the two cannot describe the same dot differently.
 */
export function sectionBadge(label: string, items: readonly NavRailItem[]): SectionBadge {
  const badged = items.find((item) => item.badge !== undefined && item.badge > 0);
  if (!badged) return { has: false, name: label };
  const count = badged.badge ?? 0;
  const words = badged.badgeLabel ? badged.badgeLabel(count) : `${count}`;
  return { has: true, name: `${label}, ${words} in ${badged.label}` };
}
